import { TpaPageIds } from './utils/verticals/page-mapping';
export const SITE_LEVEL_PAGE_ID = 'site-level';
export const ACCESSIBILITY_WIZARD_TAB_IDS = {
  DETECTED_TASKS: 'DETECTED_TASKS',
  MANUAL_TASKS: 'MANUAL_TASKS'
};
export const ACCESSIBILITY_TIPS_ARTICLE_ID = '674d7454-b62d-4d3a-8a53-ff75b308ad3a';
export const PERMISSIONS_ARTICLE_ID = '9d39ce94-7943-4fbe-aabe-24f09516031b';
export const HTTP_PREFIX = 'http';
export const ADVANCED_SETTINGS_ARTICLE_ID = '00b5ddcf-a787-4cb2-b1cd-ee4c7336c9b1';
export const SUPPORTED_TPA_PAGE_IDS = Object.values(TpaPageIds);
export const ACCESSIBLITY_WIZARD_APP_DEF_ID = '9699c03d-5c19-4a7c-a454-e8109a6e43fc';
export const STUDIO_COMP_REF_TYPE = 'DESKTOP';
export const TPA_PAGE_ANALYSIS_FAILED_THRESHOLD_PERCENTAGE = 10;
export const THANK_YOU_PAGE_TPA_ID = 'thank_you_page';
export const ACCESSIBILITY_PERMISSIONS = {
  EDITOR_SAVE: 'html-editor.save',
  MONITORING_REPORT_CREATE: 'ACCESSIBILITY.MONITORING_REPORT_CREATE',
  MONITORING_REPORT_READ: 'ACCESSIBILITY.MONITORING_REPORT_READ',
  RULE_DATA_WRITE: 'ACCESSIBILITY.RULE_DATA_WRITE'
};

/** Scans older than this are treated as stale during BM handoff polling. */
export const BM_LATEST_SCAN_STALE_THRESHOLD_MS = 60_000;

/** Delay between getLatestScan retries while waiting for a BM-triggered scan. */
export const BM_LATEST_SCAN_POLL_INTERVAL_MS = 2_000;

/** Max time to poll getLatestScan before falling back to analyzeFullSite. */
export const BM_LATEST_SCAN_MAX_POLL_MS = 30_000;
//# sourceMappingURL=consts.js.map